/*eslint-disable no-debugger */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Row,
  Card,
  Col,
  OverlayTrigger,
  Popover,
  Modal,
  Container,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  formatDoctorName,
  findPercentage,
  apiDataGenerationForCompare,
} from 'src/Member/utils/common';
import {
  ErrorCircle,
  ProviderBoardCertificateImage,
  ProviderEducationImage,
  FacilityIcon,
  ProviderImageWomen,
  ProviderImageMen,
  SuccessCircle,
  ProviderDetailedGenderUnknown,
  ProviderImageUnknownGender,
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../../img/findcare/FindCareSVG';
import { t } from 'i18next';
import CheckboxInput from 'src/Member/components/common/checkbox';
import { showNetworkName } from '../../../../utils/common';
import { ConfigurationSVG } from '../../../../../Admin/img/GlobalSVG';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import ProgressBar from 'src/Member/components/progressbar/progressbar';
import { axiosInstance } from '../../../../../api/axios';
import APIEndpoints from '../../../../api/APIEndpoints';
import SearchCoveredCard from '../../skeleton/SearchCoveredCard';
import {
  setShowCostClickTimestamp,
  setShowCostClickCount,
  resetShowCostClickCount,
} from 'src/redux/member/priceCompareSlice';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from 'src/Member/components/common/ToastMessage';
import { PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD } from 'src/constants';
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';
import BaseSkeleton from '../../../../components/common/skeleton';

const AcceptingNewPatientsChip = ({ variant }) => {
  return (
    <span className={`accept-new-patient-${variant} d-block`}>
      <div className="d-flex align-items-center">
        {variant === 'success' && <SuccessCircle className="success-circle" />}
        {variant === 'danger' && <ErrorCircle className="danger-circle" />}
        <span>{t('find_provider.accepting_new_patients')}</span>
      </div>
    </span>
  );
};

const InNetworkChip = ({ variant }) => {
  return (
    <span className={`in-network-${variant} d-block mt-2`}>
      <div className="d-flex align-items-center">
        {variant === 'success' && <SuccessCircle className="success-circle" />}
        {variant === 'danger' && <ErrorCircle className="danger-circle" />}
        <span>
          {variant === 'success'
            ? t('find_provider.in_network')
            : t('find_provider.out_of_network')}
        </span>
      </div>
    </span>
  );
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
const ResultCard = ({
  coveredCostLoading = false,
  data,
  elemkey,
  isAccordion = false,
  setSelectedCheckedItems,
  selectedCheckedItems,
  setSelectedCheckedRowData,
  selectedCheckedRowData,
  serachNetworksFor,
  CoveredCostComparePriceArray,
  isExternalProvider = false,
}) => {
  const showCostBtnRef = useRef(0);
  const disclaimerRef = useRef();

  const disclaimerHeaderRef = useRef(null);
  const disclaimerTitleRef = useRef(null);
  const disclaimerContentRef = useRef(null);
  const disclaimerFooterRef = useRef(null);
  const costDetailsRef = useRef();
  const [checked, setChecked] = useState(false);
  const [checkedRoster, setCheckedRoster] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isActiveCost, setIsActiveCost] = useState(false);
  const [coveredCostData, setCoveredCostData] = useState();
  const [isOpenDisclaimerPopup, setisOpenDisclaimerPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [showMoreDisclaimerButton, setShowMoreDisclaimerButton] =
    useState(false);
  const dispatch = useDispatch();
  const {
    //searchProviderParams: { Network },
    address,
    networksList,
    networkTierList,
    searchParamsForUI,
    providerType,
    searchProviderParams,
    showCostClickTimestamp,
    showCostClickCount,
    showCostClickTimeThreshold = PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
    showCostClickNumThreshold = PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.clicks,
  } = useSelector(({ priceCompare }) => priceCompare);
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Provider } = allFilters;
  const { loggedInUserOID, loggedInMemberType } = useSelector(
    (state) => state.memberSummary,
  );
  const { Find_Provider_Network } = useSelector(
    (state) => state?.app?.customNetwork,
  );
  const {
    Value_Network_For_PriceComparison_Member,
    Display_Network_For_PriceComparison_Member,
    Display_Network_Indicator_for_Price_Comparison_page,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const addressZip = useSelector(
    (state) => state?.priceCompare?.searchParamsForUI?.locationData,
  );

  const { PriceComparison_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};

  const noDataMessage = t('find_provider.data_not_available');
  const inNetworkList = [];

  if (Value_Network_For_PriceComparison_Member === 'network') {
    if (data?.InNetwork === true && data?.DoctorNetworks?.length > 0) {
      data?.DoctorNetworks.forEach((eachNetwork) => {
        if (
          networkTierList.findIndex((ele) => ele.value === eachNetwork) !== -1
        ) {
          inNetworkList.push(eachNetwork);
        }
      });
    }
  }
  let uniqueTier = [];
  if (Value_Network_For_PriceComparison_Member === 'tier') {
    const tierArr = [];
    if (data.DoctorNetworks?.length > 0) {
      networkTierList.forEach((eachNetwork) => {
        if (
          data.DoctorNetworks.findIndex(
            (ele) => ele === eachNetwork.NetworkDescription,
          ) !== -1
        ) {
          tierArr.push(eachNetwork.NetworkTier);
        }
      });
      uniqueTier = [...new Set(tierArr)];
      uniqueTier.sort();
    }
  }

  const onSelectRowHandler = (e, data, ConnectorId) => {
    if (data?.CignaProviderFlag === 'R') {
      setCheckedRoster(e.target.checked);
    } else {
      setChecked(e.target.checked);
    }

    if (e.target.checked) {
      dispatch(setSelectedCheckedItems([...selectedCheckedItems, ConnectorId]));
      dispatch(setSelectedCheckedRowData([...selectedCheckedRowData, data]));
    } else {
      dispatch(
        setSelectedCheckedItems(
          selectedCheckedItems.filter((id) => id !== ConnectorId),
        ),
      );
      dispatch(
        setSelectedCheckedRowData(
          selectedCheckedRowData.filter(
            (item) => item.ConnectorId !== ConnectorId,
          ),
        ),
      );
    }
  };

  const onToggleClickHandler = () => {
    setIsActive(!isActive);
  };
  function apiDataGenerationForCompare({
    loggedInUserOID,
    loggedInMemberType,
    searchParamsForUI,
  }) {
    const DATA = [];
    let billedAmountVal;

    if (searchParamsForUI?.billedamount === '') {
      billedAmountVal = Number(searchParamsForUI?.billedamount);
    } else {
      billedAmountVal = searchParamsForUI?.billedamount;
    }
    const obj = {
      MemberType: loggedInMemberType,
      SelEmployeeMemberOID: loggedInUserOID,
      Serviceprovider: data.ConnectorId || '',
      BilledAmt: billedAmountVal,
    };
    if (data?.CignaProviderFlag === 'R') {
      obj.ProviderNPID = data?.NationalProviderId;
      obj.Providertaxid = data?.TaxID || data?.TaxId;
      obj.ProvAddress1 = data?.Address?.AddressLine1 || data?.Address1;
      obj.ProvAddress2 = data?.Address?.AddressLine2 || data?.Address2;
      obj.ProvAddress3 = data?.Address?.AddressLine3 || data?.Address3;
      obj.ProvState = data?.Address?.State || data?.StateProv;
      obj.ProvCity = data?.Address?.City || data?.City;
      obj.ProvCounty =
        data?.Address?.County || data?.County === null
          ? undefined
          : data?.County;
      obj.ProvZipCode = data?.Address?.PostalCode || data?.PostalCode;
      delete obj.Serviceprovider;
    }
    if (searchParamsForUI?.helthProcedureData?.codeName) {
      switch (searchParamsForUI?.helthProcedureData?.codeName) {
        case 'CPT4 Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CPTCode';
          break;
        case 'Revenue Codes':
          obj.RevenueCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'Revenue';
          obj.CodeDescription = 'RevenueCode';
          break;
        case 'CDT5 Dental Codes':
          obj.CDT = searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CDT';
          obj.CodeDescription = 'CDTCode';
          break;
        case 'DRG Codes':
          obj.DRGCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'DRGCode';
          obj.CodeDescription = 'DRGCode';
          break;
        case 'HCPCS Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        case 'CPT':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        default:
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = '';
          obj.CodeDescription = '';
          break;
      }
    }
    //obj.CodeOption =  "Revenue";
    //obj.RevenueCode = "0000";
    if (searchProviderParams?.selectedNetwork?.NetworkCode) {
      obj.NetworkID = searchProviderParams?.selectedNetwork?.NetworkCode;
    }
    DATA.push(obj);
    return DATA;
  }
  const API_PAYLOAD = {
    pricecompareClaim: {
      searchParams: {
        providerType: providerType,
        procedureForData: searchParamsForUI?.procedureForData,
        helthProcedureData: searchParamsForUI?.helthProcedureData,
        locationData: searchParamsForUI?.locationData,
        providerByData: searchParamsForUI?.filters?.providerByData
          ? searchParamsForUI?.filters?.providerByData
          : searchParamsForUI?.providerByData,
        networksData: searchParamsForUI?.networksData,
        typesOfSpecialtyData: searchParamsForUI?.typesOfSpecialtyData,
        maximumradius: searchProviderParams?.filters?.maximumradius,
        Gender: searchProviderParams?.filters?.Gender,
        AcceptingNewPatients: searchProviderParams?.AcceptingNewPatients,
        spokenlanguages: searchProviderParams?.filters?.spokenlanguages,
        specialities: searchProviderParams?.filters?.specialities,
        BilledAmt: searchParamsForUI?.billedamount,
      },
      comparison: {
        selectedCheckedItems: [data.ConnectorId],
        selectedCheckedRowData: [data],
      },
      apiData: apiDataGenerationForCompare({
        loggedInUserOID,
        loggedInMemberType,
        selectedCheckedItems,
        searchParamsForUI,
      }),
    },
  };
  const PriceCompareCoveredCost = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        APIEndpoints.getComparedRequestId() + '/storeasrecent/true',
        API_PAYLOAD,
      );
      console.log('PriceCompareCoveredCost', response);
      const ClaimNumber =
        response.data.Response.PriceCompareClaimDTO[0].ClaimNumber;
      //|| '223-0000002331-00';
      const RequestId =
        response.data.Response.PriceCompareClaimDTO[0].RequestId;
      const DataItem = await axiosInstance.get(
        APIEndpoints.getCompareClaimDetails() +
          ClaimNumber +
          (RequestId ? `/requestid/${RequestId}` : ''),
      );
      console.log('DataItem', DataItem);
      const Covered = [
        {
          ...DataItem.data.Response.ReadClaimDTO[0],
          Serviceprovider: data.ConnectorId,
          Disclaimer: response.data.Response.PriceCompareClaimDTO[0].Disclaimer,
          /*ClaimStatus:
            response.data.Response.PriceCompareClaimDTO[0].ClaimStatus,*/
        },
      ];
      console.log('Covered HERE', Covered);
      Covered['Serviceprovider'] = data.ConnectorId;
      Covered['Disclaimer'] =
        response.data.Response.PriceCompareClaimDTO[0].Disclaimer || '';
      setCoveredCostData(Covered[0]);
      CoveredCostComparePriceArray?.CoveredCostComparePriceArray.push(Covered);
      setIsActiveCost(true);
      setLoading(false);
    } catch {
      setError(true);
      setLoading(false);
    }
  };
  const handleClose = () => {
    setisOpenDisclaimerPopup(false);
  };
  const onToggleClickHandlerCost = () => {
    if (showCostBtnRef?.current < 10) {
      showCostBtnRef.current = 1;
      if (
        showCostClickCount >= showCostClickNumThreshold &&
        showCostClickTimestamp &&
        moment().unix() < parseInt(showCostClickTimestamp)
      ) {
        dispatch(setShowCostClickTimestamp());
        toast.error(
          <ToastMessage
            subTitle={`The maximum number of requests has been reached. You can submit the next request in 30 seconds.`}
            type="error"
          />,
        );
      } else {
        if (
          showCostClickTimestamp === null ||
          moment().unix() > showCostClickTimestamp
        ) {
          dispatch(setShowCostClickTimestamp());
          dispatch(resetShowCostClickCount());
        }
        dispatch(setShowCostClickCount());
        if (
          CoveredCostComparePriceArray?.CoveredCostComparePriceArray.length > 0
        ) {
          const showCover =
            CoveredCostComparePriceArray?.CoveredCostComparePriceArray.filter(
              (covered) => covered.Serviceprovider === data.ConnectorId,
            );
          console.log('showCover data', data);
          console.log('showCover', showCover[0]);
          if (showCover.length > 0) {
            setCoveredCostData(showCover[0][0]);
            setIsActiveCost(true);
          } else {
            PriceCompareCoveredCost();
          }
        } else {
          PriceCompareCoveredCost();
        }
      }
    }
  };

  useEffect(() => {
    if (isActiveCost) {
      if (costDetailsRef && costDetailsRef?.current) {
        costDetailsRef?.current?.focus();
      }
    }
  }, [isActiveCost]);

  useEffect(() => {
    if (data.CignaProviderFlag === 'R') {
      setCheckedRoster(selectedCheckedItems.includes(data.ConnectorId));
    } else {
      setChecked(selectedCheckedItems.includes(data.ConnectorId));
    }
  }, [selectedCheckedItems, data.ConnectorId, data.CignaProviderFlag]);

  useEffect(() => {
    if (disclaimerRef && disclaimerRef.current) {
      if (
        disclaimerRef?.current?.offsetWidth <
        disclaimerRef?.current?.scrollWidth
      ) {
        setShowMoreDisclaimerButton(true);
      } else {
        setShowMoreDisclaimerButton(false);
      }
    }
  }, [disclaimerRef]);

  useEffect(() => {
    if (isOpenDisclaimerPopup) {
      disclaimerTitleRef && disclaimerTitleRef?.current?.focus();
      setTimeout(() => {
        disclaimerHeaderRef &&
          disclaimerHeaderRef?.current?.removeAttribute('aria-hidden');
        disclaimerContentRef &&
          disclaimerContentRef?.current?.removeAttribute('aria-hidden');
        disclaimerFooterRef &&
          disclaimerFooterRef?.current?.removeAttribute('aria-hidden');
      }, 1000);
    }
  }, [isOpenDisclaimerPopup]);

  const CoverageFormat = (coverage) => {
    if (coverage) {
      const data = coverage.toString().replace(/,/g, '');
      return formatter.format(data);
    } else {
      return formatter.format(coverage);
    }
  };
  console.log('RESULT CARD data', data);
  return (
    <Fragment>
      <div className="dashboard-navbar mb-4" role="rowgroup">
        <Card className="provider-details-card">
          <Row
            className={`profile-primary-info m-0 align-items-center justify-content-between ${
              isAccordion && !isActive && 'paddTop0'
            } ${
              coveredCostData?.Error &&
              coveredCostData?.Error !== '' &&
              'paddTop10'
            }`}
            role="row"
          >
            <Col lg={6} md={6} xs={11} className="p-0 m-0" role="cell">
              <div className="d-flex align-items-center no-flex-mobile">
                {isAccordion && (
                  <div className="mr-3 mb-4">
                    <CheckboxInput
                      inline
                      key={data.ConnectorId}
                      label=""
                      name={data.ConnectorId}
                      value={data.ConnectorId}
                      className="cursor-pointer"
                      id={data.ConnectorId}
                      onChange={(e) => {
                        onSelectRowHandler(e, data, data.ConnectorId);
                      }}
                      checked={
                        data?.CignaProviderFlag === 'R'
                          ? checkedRoster
                          : checked
                      }
                      isDisabled={
                        selectedCheckedItems.length >= 3 &&
                        (data?.CignaProviderFlag === 'R'
                          ? !checkedRoster
                          : !checked) &&
                        !selectedCheckedItems.includes(data.ConnectorId)
                      }
                      ariaDisabled={
                        selectedCheckedItems.length >= 3 &&
                        (data?.CignaProviderFlag === 'R'
                          ? !checkedRoster
                          : !checked) &&
                        !selectedCheckedItems.includes(data.ConnectorId)
                      }
                      ariaLabel={
                        selectedCheckedItems.length >= 3 &&
                        (data?.CignaProviderFlag === 'R'
                          ? !checkedRoster
                          : !checked) &&
                        !selectedCheckedItems.includes(data.ConnectorId)
                          ? 'you have selected maximum 3 providers to compare'
                          : 'select the providers to compare'
                      }
                    />
                  </div>
                )}
                {Provider === 'facility' ? (
                  <FacilityIcon
                    className="image-color"
                    circleClassName="circle-color"
                  />
                ) : (
                  <>
                    {data?.Gender === 'Female' && (
                      <ProviderImageWomen
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                    {data?.Gender === 'Male' && (
                      <ProviderImageMen
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                    {(!data?.Gender || data?.Gender?.trim() === 'Unknown') && (
                      <ProviderImageUnknownGender
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                  </>
                )}
                <div className="ml-3 doctor-details-container">
                  {Provider === 'facility' ? (
                    <>
                      {data?.FacilityName?.length > 22 ? (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 200, hide: 450 }}
                          overlay={
                            <Popover>
                              <Popover.Content>
                                <div className="tooltip-header">
                                  {data?.FacilityName}
                                </div>
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <p
                            className="m-0 provider-name"
                            id={`provider-name-${data?.FacilityID}`}
                          >
                            {isExternalProvider ? (
                              data?.FacilityName
                            ) : (
                              <Link
                                to={`/member/price-compare/facility-details/${data.FacilityID}/${data?.PostalCode}`}
                                state={{
                                  memberType:
                                    searchParamsForUI?.procedureForData
                                      .memberType,
                                  memberOid:
                                    searchParamsForUI?.procedureForData.value,
                                }}
                              >
                                {data?.FacilityName}
                              </Link>
                            )}
                          </p>
                        </OverlayTrigger>
                      ) : (
                        <p
                          className="m-0 provider-name"
                          id={`provider-name-${data?.FacilityID}`}
                        >
                          {isExternalProvider ? (
                            data?.FacilityName
                          ) : (
                            <Link
                              to={`/member/price-compare/facility-details/${data?.FacilityID}/${data?.PostalCode}`}
                              state={{
                                memberType:
                                  searchParamsForUI?.procedureForData
                                    .memberType,
                                memberOid:
                                  searchParamsForUI?.procedureForData.value,
                              }}
                            >
                              {data?.FacilityName}
                            </Link>
                          )}
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {formatDoctorName(
                        data?.DoctorTitle,
                        data?.LastName,
                        data?.FirstName,
                        data?.MiddleName,
                        data?.Suffix,
                      )?.length > 22 ? (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 200, hide: 450 }}
                          overlay={
                            <Popover>
                              <Popover.Content>
                                <div className="tooltip-header">
                                  {formatDoctorName(
                                    data?.DoctorTitle,
                                    data?.LastName,
                                    data?.FirstName,
                                    data?.MiddleName,
                                    data?.Suffix,
                                  )}
                                </div>
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <p
                            className="m-0 provider-name"
                            id={`provider-name-${data?.PhysicianID}`}
                          >
                            {isExternalProvider ? (
                              formatDoctorName(
                                data?.DoctorTitle,
                                data?.LastName,
                                data?.FirstName,
                                data?.MiddleName,
                                data?.Suffix,
                              )
                            ) : (
                              <Link
                                to={`/member/price-compare/doctor-details/${data.PhysicianID}/${addressZip}`}
                              >
                                {formatDoctorName(
                                  data?.DoctorTitle,
                                  data?.LastName,
                                  data?.FirstName,
                                  data?.MiddleName,
                                  data?.Suffix,
                                )}
                              </Link>
                            )}
                          </p>
                        </OverlayTrigger>
                      ) : (
                        <p
                          className="m-0 provider-name"
                          id={`provider-name-${data?.PhysicianID}`}
                        >
                          {isExternalProvider ? (
                            formatDoctorName(
                              data?.DoctorTitle,
                              data?.LastName,
                              data?.FirstName,
                              data?.MiddleName,
                              data?.Suffix,
                            )
                          ) : (
                            <Link
                              to={`/member/price-compare/doctor-details/${data.PhysicianID}/${addressZip}`}
                            >
                              {formatDoctorName(
                                data?.DoctorTitle,
                                data?.LastName,
                                data?.FirstName,
                                data?.MiddleName,
                                data?.Suffix,
                              )}
                            </Link>
                          )}
                        </p>
                      )}
                    </>
                  )}
                  <p className="m-0 provider-spacality">
                    {/*#TODO: experience is not available in JV as per story 357  {18 years in Practice |}  */}
                    {data?.Experiance && `${data?.Experiance} in Practice |`}{' '}
                    {Provider === 'facility'
                      ? data?.FacilitySpeciality &&
                        data?.FacilitySpeciality.join(', ')
                      : data?.Specialties && data?.Specialties.join(', ')}
                  </p>
                  {data.ShowNetwork && (
                    <div className="section-networks network-hide-handler">
                      {Display_Network_Indicator_for_Price_Comparison_page ? (
                        data.InNetwork === true ? (
                          <InNetworkChip variant="success" />
                        ) : (
                          <InNetworkChip variant="danger" />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                  {/*Number(data?.Distance) > 0 && (
                    <p className="provider-get-driections d-block d-md-none mt-3 mt-md-0">
                      {
                        (data?.Coordinateds || data?.Address?.Coordinateds) && (
                          //<Link
                          //to={{
                          //pathname: `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${data.Address.Coordinateds}`
                          //}}
                          //target="_blank">
                          <span className="secondary-2">
                            {t('member.price_comparison.result_card_distance')}
                          </span>
                        )
                        //</Link>
                      }
                      <br />
                      <span className="distance-count">
                        {data?.Distance &&
                          `${data?.Distance} mile${
                            Number(data?.Distance) > 1 ? 's' : ''
                          }`}
                      </span>
                    </p>
                        )*/}
                  {Provider === 'facility' ? (
                    <>
                      {Number(data?.Miles_Distance) > 0 && (
                        <p className="provider-get-driections d-block d-md-none mt-3 mt-md-0">
                          {
                            data?.Coordinateds && (
                              //<Link
                              //to={{
                              //pathname: `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${data.Address.Coordinateds}`
                              //}}
                              //target="_blank">
                              <span className="secondary-2">
                                {t(
                                  'member.price_comparison.result_card_distance',
                                )}
                              </span>
                            )
                            //</Link>
                          }
                          <br />
                          <span className="distance-count">
                            {data?.Miles_Distance &&
                              `${data?.Miles_Distance} mile${
                                Number(data?.Miles_Distance) > 1 ? 's' : ''
                              }`}
                          </span>
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {Number(data?.Distance) > 0 && (
                        <p className="provider-get-driections d-block d-md-none mt-3 mt-md-0">
                          {
                            data?.Address?.Coordinateds && (
                              //<Link
                              //to={{
                              //pathname: `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${data.Address.Coordinateds}`
                              //}}
                              //target="_blank">
                              <span className="secondary-2">
                                {t(
                                  'member.price_comparison.result_card_distance',
                                )}
                              </span>
                            )
                            //</Link>
                          }
                          <br />
                          <span className="distance-count">
                            {data?.Distance &&
                              `${data?.Distance} mile${
                                Number(data?.Distance) > 1 ? 's' : ''
                              }`}
                          </span>
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Col>
            <Col
              md={isAccordion ? 4 : 4}
              xs={isAccordion ? 11 : 12}
              className="m-0 p-0 d-flex justify-content-end align-items-center"
              role="cell"
            >
              {data.ShowNetwork && (
                <div className="section-networks">
                  {Display_Network_Indicator_for_Price_Comparison_page ? (
                    data.InNetwork === true ? (
                      <InNetworkChip variant="success" />
                    ) : (
                      <InNetworkChip variant="danger" />
                    )
                  ) : (
                    ''
                  )}
                </div>
              )}
              {/*Number(data?.Distance) > 0 && (
                <div className="provider-get-driections mt-3 mt-md-0 pr-3">
                  {(data?.Coordinateds || data?.Address?.Coordinateds) && (
                    <span className="secondary-2">
                      {t('member.price_comparison.result_card_distance')}
                    </span>
                  )}
                  <br />
                  <span className="distance-count">
                    {data?.Distance &&
                      `${data?.Distance} mile${
                        Number(data?.Distance) > 1 ? 's' : ''
                      }`}
                  </span>
                </div>
                    )*/}
              {Provider === 'facility' ? (
                <>
                  {Number(data?.Miles_Distance) > 0 && (
                    <div className="provider-get-driections mt-3 mt-md-0 pr-3">
                      {data?.Coordinateds && (
                        <span className="secondary-2">
                          {t('member.price_comparison.result_card_distance')}
                        </span>
                      )}
                      <br />
                      <span className="distance-count">
                        {data?.Miles_Distance &&
                          `${data?.Miles_Distance} mile${
                            Number(data?.Miles_Distance) > 1 ? 's' : ''
                          }`}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {Number(data?.Distance) > 0 && (
                    <div className="provider-get-driections mt-3 mt-md-0 pr-3">
                      {data?.Address?.Coordinateds && (
                        <span className="secondary-2">
                          {t('member.price_comparison.result_card_distance')}
                        </span>
                      )}
                      <br />
                      <span className="distance-count">
                        {data?.Distance &&
                          `${data?.Distance} mile${
                            Number(data?.Distance) > 1 ? 's' : ''
                          }`}
                      </span>
                    </div>
                  )}
                </>
              )}
              {isAccordion && !coveredCostData?.Error && (
                <div
                  className="tabContainer pr-2"
                  role="button"
                  tabIndex={0}
                  onClick={() => onToggleClickHandler()}
                  aria-expanded={isAccordion && isActive}
                  id={isAccordion && `section-${elemkey}`}
                  aria-controls={isAccordion && `section-${elemkey}`}
                  aria-label={
                    isAccordion && isActive
                      ? 'Opened the Provider Details Panel'
                      : 'Closed the Provider Details Panel'
                  }
                >
                  <span className="sr-only">
                    Details of{' '}
                    {formatDoctorName(
                      data?.DoctorTitle,
                      data?.LastName,
                      data?.FirstName,
                      data?.MiddleName,
                      data?.Suffix,
                    )}{' '}
                    provider details
                  </span>
                  <span className="tab">
                    {isActive ? (
                      <AccordionUpArrow className="acc-tab" />
                    ) : (
                      <AccordionDownArrow className="acc-tab" />
                    )}
                  </span>
                </div>
              )}
            </Col>
            {!coveredCostData?.Error && (
              <Col
                md={isAccordion ? 2 : 3}
                xs={isAccordion ? 11 : 12}
                className="py-2 pr-2 m-0 border-left d-flex align-items-stretch justify-content-center"
                role="cell"
              >
                <div className="cost-section pb-2 pt-1" role="section">
                  <>
                    {isActiveCost && (
                      <span
                        className="sr-only"
                        ref={costDetailsRef}
                        tabIndex={0}
                      >
                        Details of Costs Section
                      </span>
                    )}
                    {coveredCostLoading ? (
                      <div>
                        <BaseSkeleton count={1} height={40} />
                      </div>
                    ) : isExternalProvider && data?.Rate ? (
                      <div
                        className={`d-none mt-1 patient_responsibility covered-cost ${
                          (isActiveCost || isExternalProvider) && 'd-block'
                        }`}
                      >
                        <p className="title m-0 text-center">Covered Cost</p>
                        <p className="m-0 text-center value">
                          {CoverageFormat(data?.Rate)}
                        </p>
                      </div>
                    ) : (
                      //!isExternalProvider &&
                      coveredCostData?.Covered && (
                        <div
                          className={`d-none mt-1 patient_responsibility covered-cost ${
                            (isActiveCost || isExternalProvider) && 'd-block'
                          }`}
                        >
                          <p className="title m-0 text-center">Covered Cost</p>
                          <p className="m-0 text-center value">
                            {CoverageFormat(coveredCostData?.Covered)}
                          </p>
                        </div>
                      )
                    )}
                    <div
                      className={`d-none mt-1 patient_responsibility covered-cost ${
                        isActiveCost && 'd-block'
                      }`}
                    >
                      <p className="title m-0 text-center">
                        Patient Responsibility
                      </p>
                      <p className="m-0 text-center value">
                        {CoverageFormat(coveredCostData?.YouMayOwe)}
                      </p>
                    </div>
                  </>
                  <div className={`mt-1  ${isActiveCost && 'd-none'}`}>
                    <GenericButton
                      className="ml-0 ml-md-1 mt-2 mt-md-0 show-cost-button"
                      id="show-cost"
                      variant="secondary"
                      onClick={() => onToggleClickHandlerCost()}
                    >
                      {t('member.price_comparison.show_cost_button')}
                    </GenericButton>
                  </div>
                </div>
              </Col>
            )}
          </Row>
          {loading ? (
            <SearchCoveredCard />
          ) : (
            <Row
              tabIndex={0}
              role={isAccordion && 'region'}
              className={`profile-seconday-info  ${
                isAccordion && 'accordion-content'
              } ${isActiveCost && 'accordion-content-open'}`}
              id={isAccordion && `section-cost${elemkey}`}
              aria-labelledby={isAccordion && `section-cost-details${elemkey}`}
            >
              <div
                role="row"
                className={`d-flex flex-adjuster w-100 ${
                  !isAccordion && !isActiveCost && 'padTop'
                } ${isAccordion && isActiveCost && 'padTop'} ${
                  isAccordion && 'row-item'
                }`}
                id={`section-cost-details${elemkey}`}
              >
                <div role="cell" className="cost-details col pb-3 pb-md-0">
                  {coveredCostData?.Error && coveredCostData?.Error !== '' ? (
                    <GeneralMessage
                      message={
                        coveredCostData?.Error ||
                        'Your request is in progress! You can navigate to Recent Request later to view your Estimates.'
                      }
                    />
                  ) : (
                    <div className="count-details-container">
                      <div className="left-container">
                        <div className="container-heading">
                          {t(
                            'member.price_comparison.finalResultTile.pricing_details',
                          )}
                        </div>
                        <div
                          className="count-details-main-wrapper"
                          role="section"
                        >
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.plan_pay',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.plan_pay',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(coveredCostData?.PlanPay)}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            {/*Disallowed removing based on Navin Comment on JMP-8964 */}
                            {/*<span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.disallowed',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.disallowed',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(
                                coveredCostData?.Disallowed -
                                  coveredCostData?.Copay -
                                  (coveredCostData?.YouMayOwe -
                                    coveredCostData?.Copay -
                                    coveredCostData?.CoInsurance -
                                    coveredCostData?.Deductible),
                              )}
                            </span> */}
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.deductible',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.deductible',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(coveredCostData?.Deductible)}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.copay',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.copay',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(coveredCostData?.Copay)}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.deductibleRemaining',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.deductibleRemaining',
                              )}
                            </span>
                            <span className="data-value">
                              {`${CoverageFormat(
                                coveredCostData?.NetIndDedMet,
                              )}/${CoverageFormat(
                                Number(coveredCostData?.NetIndDedMax) -
                                  Number(coveredCostData?.NetIndDedMet),
                              )}`}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.co_insurance',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.co_insurance',
                              )}
                            </span>
                            <span className="data-value">
                              {' '}
                              {CoverageFormat(coveredCostData?.CoInsurance)}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.other',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.other',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(coveredCostData?.Other)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="right-container">
                        <div className="container-heading">
                          {t(
                            'member.price_comparison.finalResultTile.out_of_pocket',
                          )}
                        </div>
                        <div className="sr-only" id="accessibility-progressbar">
                          {data?.rightSideData?.OutOfPocket}% completed out of
                          100%
                        </div>
                        <div aria-describedby="accessibility-progressbar">
                          <ProgressBar
                            completed={findPercentage(
                              coveredCostData?.NetIndOOPMet,
                              coveredCostData?.NetIndOOPMax,
                            )}
                          />
                        </div>
                        <div
                          className="count-details-main-wrapper"
                          role="section"
                        >
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.applied',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.applied',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(coveredCostData?.NetIndOOPMet)}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.remaining',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.remaining',
                              )}{' '}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(
                                coveredCostData?.NetIndOOPMax -
                                  coveredCostData?.NetIndOOPMet >
                                  0
                                  ? coveredCostData?.NetIndOOPMax -
                                      coveredCostData?.NetIndOOPMet
                                  : 0,
                              )}
                            </span>
                          </div>
                          <div className="detils-wrapper">
                            <span
                              className="data-heading"
                              role="sectionhead"
                              aria-label={t(
                                'member.price_comparison.finalResultTile.maximum',
                              )}
                            >
                              {t(
                                'member.price_comparison.finalResultTile.maximum',
                              )}
                            </span>
                            <span className="data-value">
                              {CoverageFormat(coveredCostData?.NetIndOOPMax)}
                            </span>
                          </div>
                        </div>
                      </div>
                      {coveredCostData?.Disclaimer && (
                        <div className="d-flex gap-3 align-items-center mt-3">
                          <div className="disclaimer-svg">
                            <ConfigurationSVG.WarningSVG />
                          </div>
                          <div className="warning-content mt-1 ml-2">
                            <GenericButton
                              variant="link"
                              className="viewmore-btn p-0"
                              onClick={() => {
                                setisOpenDisclaimerPopup(
                                  !isOpenDisclaimerPopup,
                                );
                              }}
                              ariaLabel="Click to open disclaimer panel."
                            >
                              Disclaimer
                            </GenericButton>
                            {/*<span className="content-bold">
                              Disclaimer: {''}
                            </span> */}
                            {/*<span
                              className="disclaimer-text"
                              ref={disclaimerRef}
                            >
                              {' '}
                              {coveredCostData.Disclaimer}
                            </span> */}
                            {/*{showMoreDisclaimerButton && (
                              <span
                                className="button-position"
                                aria-hidden={true}
                              >
                                <GenericButton
                                  variant="link"
                                  className="viewmore-btn"
                                  onClick={() => {
                                    setisOpenDisclaimerPopup(
                                      !isOpenDisclaimerPopup,
                                    );
                                  }}
                                >
                                  View More
                                </GenericButton>
                              </span>
                            )} */}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Row>
          )}
          <Row
            tabIndex={0}
            role={isAccordion && 'region'}
            className={`profile-seconday-info  ${
              isAccordion && 'accordion-content'
            } ${isActive && 'accordion-content-open'}`}
            id={isAccordion && `section-${elemkey}`}
            aria-labelledby={isAccordion && `section-${elemkey}`}
          >
            <div
              role="row"
              className={`d-flex flex-adjuster w-100 ${
                !isAccordion && !isActive && 'padTop'
              } ${isAccordion && isActive && 'padTop'} ${
                isAccordion && 'row-item'
              }`}
            >
              <div
                role="cell"
                className="col-xs-12 border-right-info col-md-4 pb-3 pb-md-0"
              >
                {Provider === 'facility' ? (
                  <div className="provider-location-info">
                    <p className="provider-location-data">
                      {/*{!data?.Gender || data.Gender === 'Unknown'
                        ? 'N/A (Gender)'
                        : `${data?.Gender} (Gender)`}{' '}
                      {data?.Experiance
                        ? ` | ${data?.Experiance} years in Practice`
                        : ''} */}
                    </p>
                    <p className="provider-location-data">
                      {data?.Address1 && `${data?.Address1}, `}
                      {data?.Address2 && `${data?.Address2}, `}
                      {data?.Address3 && `${data?.Address3}, `}
                      {data?.City && `${data?.City}, `}
                      {data?.County && `${data?.County}, `}
                      {data?.StateProv && `${data?.StateProv}, `}
                      {data?.PostalCode && `${data?.PostalCode}`}
                    </p>
                    <p className="provider-contact-data">
                      {data.Phone ? data.Phone : noDataMessage}
                    </p>
                  </div>
                ) : (
                  <div className="provider-location-info">
                    <p className="provider-location-data">
                      {!data?.Gender || data.Gender === 'Unknown'
                        ? 'N/A (Gender)'
                        : `${data?.Gender} (Gender)`}{' '}
                      {data?.Experiance
                        ? ` | ${data?.Experiance} years in Practice`
                        : ''}
                    </p>
                    <p className="provider-location-data">
                      {data?.Address?.AddressLine1 &&
                        `${data?.Address?.AddressLine1}, `}
                      {data?.Address?.AddressLine2 &&
                        `${data?.Address?.AddressLine2}, `}
                      {data?.Address?.AddressLine3 &&
                        `${data?.Address?.AddressLine3}, `}
                      {data?.Address?.City && `${data?.Address?.City}, `}
                      {data?.Address?.County && `${data?.Address?.County}, `}
                      {data?.Address?.State && `${data?.Address?.State}, `}
                      {data?.Address?.PostalCode &&
                        `${data?.Address?.PostalCode}`}
                    </p>
                    <p className="provider-contact-data">
                      {data.Phone ? data.Phone : noDataMessage}
                    </p>
                  </div>
                )}
              </div>
              {Provider !== 'facility' && (
                <div
                  role="cell"
                  className="col-md-3 col-xs-12 border-right-info pb-3 pb-md-0"
                >
                  <div className="section-networks">
                    <div className="mt-3">
                      {data.AcceptingNewPatients === true ? (
                        <AcceptingNewPatientsChip variant="success" />
                      ) : (
                        <AcceptingNewPatientsChip variant="danger" />
                      )}
                      <div className="provider-languages-info mt-3">
                        <p className="provider-language-heading">
                          {t('find_provider.language_spoken')}
                        </p>
                        <p className="provider-languages-data">
                          {data?.SpokenLanguages?.length > 0
                            ? data?.SpokenLanguages?.join(', ')
                            : noDataMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div role="cell" className="col-xs-12 col-md-5 mt-3 mt-md-0">
                {data.InNetwork === true &&
                  Display_Network_For_PriceComparison_Member && (
                    <div>
                      <p className="provider-contact-heading m-0 p-0 mt-2">
                        {Value_Network_For_PriceComparison_Member === 'tier' &&
                        uniqueTier?.length > 0
                          ? t(
                              'member.price_comparison.provider_container.networks_dropdown_labelTier',
                            )
                          : Value_Network_For_PriceComparison_Member ===
                              'network' && inNetworkList?.length > 0
                          ? t(
                              'member.price_comparison.provider_container.networks_dropdown_label',
                            )
                          : ''}
                      </p>
                      <div className="networks-list">
                        {Value_Network_For_PriceComparison_Member ===
                          'network' && (
                          <>
                            {inNetworkList?.length > 0 &&
                              data.InNetwork === true && (
                                <>
                                  {inNetworkList
                                    ?.slice(0, 2)
                                    .map((networkName, index) => {
                                      return (
                                        <React.Fragment
                                          key={`${networkName} ${index}`}
                                        >
                                          {serachNetworksFor?.value ===
                                          networkName ? (
                                            <span className="d-flex align-items-start">
                                              <span className="network-success">
                                                <SuccessCircle className="success-circle" />
                                              </span>
                                              <span className="ml-2">
                                                <span className="provider-contact-heading">
                                                  {showNetworkName(
                                                    Find_Provider_Network,
                                                    networkName,
                                                  )}
                                                  {inNetworkList?.indexOf(
                                                    networkName,
                                                  ) !==
                                                  inNetworkList?.length - 1
                                                    ? ','
                                                    : ''}
                                                </span>
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="provider-contact-data mt-1 mb-1">
                                              {showNetworkName(
                                                Find_Provider_Network,
                                                networkName,
                                              )}
                                              {inNetworkList?.indexOf(
                                                networkName,
                                              ) !==
                                              inNetworkList?.length - 1
                                                ? ','
                                                : ''}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  {inNetworkList?.length > 2 &&
                                    (Provider === 'facility' ? (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/member/price-compare/facility-details/${data?.FacilityID}/${address}`}
                                          state={{
                                            memberType:
                                              searchParamsForUI
                                                ?.procedureForData.memberType,
                                            memberOid:
                                              searchParamsForUI
                                                ?.procedureForData.value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{inNetworkList?.length - 2}{' '}
                                            {t('find_provider.networks')}
                                          </span>
                                        </Link>
                                      </span>
                                    ) : (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/member/price-compare/doctor-details/${data?.PhysicianID}/${address}`}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{inNetworkList?.length - 2}{' '}
                                            {t('find_provider.networks')}
                                          </span>
                                        </Link>
                                      </span>
                                    ))}
                                </>
                              )}
                          </>
                        )}
                        {Value_Network_For_PriceComparison_Member ===
                          'tier' && (
                          <>
                            {uniqueTier?.length > 0 &&
                              data.InNetwork === true && (
                                <>
                                  {uniqueTier
                                    ?.slice(0, 2)
                                    .map((networkName, index) => {
                                      return (
                                        <React.Fragment
                                          key={`${networkName} ${index}`}
                                        >
                                          {serachNetworksFor?.label ===
                                          networkName ? (
                                            <span className="d-flex align-items-start">
                                              <span className="network-success">
                                                <SuccessCircle className="success-circle" />
                                              </span>
                                              <span className="ml-2">
                                                <span className="provider-contact-heading">
                                                  {networkName}
                                                </span>
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="provider-contact-data mt-1 mb-1">
                                              {networkName}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  {uniqueTier?.length > 2 &&
                                    (Provider === 'facility' ? (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/member/price-compare/facility-details/${data?.FacilityID}/${address}`}
                                          state={{
                                            memberType:
                                              searchParamsForUI
                                                ?.procedureForData.memberType,
                                            memberOid:
                                              searchParamsForUI
                                                ?.procedureForData.value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{uniqueTier?.length - 2}{' '}
                                            {Value_Network_For_PriceComparison_Member ===
                                            'tier'
                                              ? t(
                                                  'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                                )
                                              : t(
                                                  'member.price_comparison.provider_container.networks_dropdown_label',
                                                )}
                                          </span>
                                        </Link>
                                      </span>
                                    ) : (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/member/price-compare/doctor-details/${data?.PhysicianID}/${address}`}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{uniqueTier?.length - 2}{' '}
                                            {Value_Network_For_PriceComparison_Member ===
                                            'tier'
                                              ? t(
                                                  'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                                )
                                              : t(
                                                  'member.price_comparison.provider_container.networks_dropdown_label',
                                                )}
                                          </span>
                                        </Link>
                                      </span>
                                    ))}
                                </>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </Row>
        </Card>
      </div>
      {isOpenDisclaimerPopup && (
        <div>
          <Modal
            show={isOpenDisclaimerPopup}
            onHide={handleClose}
            centered
            className={`Right-Model member generic-model`}
          >
            <Modal.Header closeButton className="plandocument-header">
              <Container
                className="px-0"
                aria-hidden={true}
                ref={disclaimerHeaderRef}
              >
                <Row className="align-items-center p-0 m-0">
                  <Col className="px-0" ref={disclaimerTitleRef} tabIndex={-1}>
                    <Modal.Title>
                      Disclaimer<span className="sr-only"> Panel Opened</span>
                    </Modal.Title>
                  </Col>
                </Row>
              </Container>
            </Modal.Header>

            <Modal.Body className="disclaimer-body">
              <Container
                className="px-0 custom-scroller modal-content-container pl-4 disclaimer-modal-container"
                aria-hidden={true}
                ref={disclaimerContentRef}
              >
                <div
                  className="warning-content"
                  dangerouslySetInnerHTML={{
                    __html: coveredCostData?.Disclaimer?.trim(),
                  }}
                />
              </Container>
            </Modal.Body>

            <Modal.Footer
              className="admin bg-white footer-class disclaimer-footer-btn"
              aria-hidden={true}
              ref={disclaimerFooterRef}
            >
              <div className="model-footer-btn txt-right p-0 m-0 border-0">
                {/*<GenericButton
                  className="p-0 m-0"
                  onClick={() => handleClose()}
                >
                  {t('label_cancel')}
                </GenericButton> */}
                <button onClick={() => handleClose()} className="close-btn">
                  Close
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </Fragment>
  );
};

export default ResultCard;
